import orderBy from 'lodash/orderBy';
/**
 * Utilities for the inbox component. Helpers for sort and filter.
 */ export function sort(items, sortItems) {
    if (!sortItems.length) {
        return items;
    }
    const sortDirs = sortItems.map((x)=>x.direction);
    const sortData = sortItems.map((si)=>{
        return si.column.getValue;
    });
    return orderBy(items, sortData, sortDirs);
}
/**
 * Filters based on the filter string.
 *
 * @param items {Array} - Items to filter.
 * @param filterValue {string} - Filter value.
 * @param columns {Array} - Grid columns.
 * @returns {Array} - Filtered items or source items if no filter to apply.
 */ export function filter(items, filterValue, columns) {
    if (!filterValue) {
        return items;
    }
    const searchParts = filterValue.toLowerCase().split(/\s+/);
    const searchableColumns = columns.map((x)=>x.getValue);
    return items.filter((item)=>{
        const values = searchableColumns.reduce((reduction, getValue)=>{
            reduction.push((getValue(item) || '').toString().toLowerCase());
            return reduction;
        }, []);
        return searchParts.every((p)=>values.some((v)=>v.indexOf(p) !== -1));
    });
}
/**
 * Applies the filters on the items.
 *
 * @param items {Array} - The items to filter.
 * @param filters {Array} - Array of filters. Each object contains a fn property with the filter function and a value property with the filter value.
 * @returns {Array} - Filtered result.
 */ export function applyColumnFilters(items, filters) {
    return filters.reduce((reduction, f)=>{
        return f.fn(reduction, f.value, f.column.getValue);
    }, items);
}
export const toggleSort = (curSort, columnId)=>{
    const currentSort = curSort || [];
    const sortItem = currentSort.find((x)=>x.column === columnId);
    const newSort = [
        ...currentSort
    ];
    if (sortItem) {
        const direction = sortItem.direction;
        const index = currentSort.indexOf(sortItem);
        if (direction === 'asc') {
            newSort[index] = {
                column: columnId,
                direction: 'desc'
            };
        } else if (direction === 'desc') {
            newSort.splice(index, 1);
        }
    } else {
        newSort.push({
            column: columnId,
            direction: 'asc'
        });
    }
    return newSort;
};
